import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './index.css'
import App from './App.jsx'

// A lazy route chunk can 404 if a redeploy has already deleted the hashed filename
// this tab was still holding a reference to. Vite reports that as a `vite:preloadError`
// event rather than a normal render error, so it bypasses any React ErrorBoundary — the
// only fix is to reload so the tab picks up the current build's asset manifest. The
// sessionStorage guard stops a genuinely offline visitor from reload-looping forever.
window.addEventListener('vite:preloadError', () => {
  if (!sessionStorage.getItem('reloaded-after-preload-error')) {
    sessionStorage.setItem('reloaded-after-preload-error', '1')
    window.location.reload()
  }
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
)
